{
    "api": {
        "title": "API reference",
        "subtitle": "Generated from the running application every time this page loads — the route table, the request objects and the controllers' own documentation. It cannot describe an endpoint that no longer exists, or miss one that was added this morning.",
        "generated": "Read from the application at {{time}}",
        "count": "{{count}} endpoints",
        "search": "Search endpoints",
        "search_placeholder": "Path, name or description",
        "no_results": "No endpoint matches that.",
        "summary": "Description",
        "authentication": "Authentication",
        "authenticated": "Signed-in session or API key",
        "public": "Public — no session required",
        "authorisation": "Permission",
        "auth_mode": {
            "request": "Declared by the request object",
            "middleware": "Enforced by route middleware",
            "controller": "Checked in the controller",
            "authenticated_only": "Authentication is enough",
            "undetermined": "Not determinable from the code"
        },
        "rate_limit": "Rate limit",
        "path_parameters": "Path parameters",
        "parameters": "Body parameters",
        "no_parameters": "This endpoint takes no body parameters.",
        "parameters_unknown": "The validation rules could not be read outside a real request ({{note}}). Consult the request object rather than assuming there are none.",
        "field": "Field",
        "rules": "Rules",
        "requirements": "Requirements",
        "expand": "Show details",
        "collapse": "Hide details",
        "openapi": "OpenAPI 3.1"
    }
}
